export default {"src":"/_next/static/media/grommet-icons_compliance.d9114444.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};